import { Injectable } from "@angular/core";
import { Observable, Subject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class ButtonActiveService {
  unstaking = new Subject<boolean>();
  unstaking$: Observable<boolean> = this.unstaking.asObservable();

  staking = new Subject<boolean>();
  staking$: Observable<boolean> = this.staking.asObservable();

  canceled = new Subject<boolean>();
  canceled$: Observable<boolean> = this.canceled.asObservable();

  claim = new Subject<boolean>();
  claim$: Observable<boolean> = this.claim.asObservable();

  withdraw = new Subject<boolean>();
  withdraw$: Observable<boolean> = this.withdraw.asObservable();

  generalLoader = new Subject<boolean>();
  generalLoader$: Observable<boolean> = this.generalLoader.asObservable();
}
